/// <amd-module name="Core/Medius.Core.Web/Scripts/components/readonlyTabs/deliveryAddress"/>
import * as React from 'react';
import { IDocumentImportInformation } from "../interfaces";
import { ContentDivider, FixedGridLayout, LockedField, Text } from "@medius/ui-controls";
import { translate } from 'Core/Medius.Core.Web/Scripts/lib/globalization';

interface DeliveryAddressDetailsProps {
    information: IDocumentImportInformation;
}

export const isAddressInformationFromNotEmpty = (information: IDocumentImportInformation): boolean =>
    (information?.addressInformationFromStreet !== null && information?.addressInformationFromStreet !== "" && information?.addressInformationFromStreet !== undefined) ||
    (information?.addressInformationFromCity !== null && information?.addressInformationFromCity !== "" && information?.addressInformationFromCity !== undefined) ||
    (information?.addressInformationFromState !== null && information?.addressInformationFromState !== "" && information?.addressInformationFromState !== undefined) ||
    (information?.addressInformationFromPostalCode !== null && information?.addressInformationFromPostalCode !== "" && information?.addressInformationFromPostalCode !== undefined) ||
    (information?.addressInformationFromCountry !== null && information?.addressInformationFromCountry !== "" && information?.addressInformationFromCountry !== undefined);

export const isAddressInformationToNotEmpty = (information: IDocumentImportInformation): boolean =>
    (information?.addressInformationToStreet !== null && information?.addressInformationToStreet !== "" && information?.addressInformationToStreet !== undefined) ||
    (information?.addressInformationToCity !== null && information?.addressInformationToCity !== "" && information?.addressInformationToCity !== undefined) ||
    (information?.addressInformationToState !== null && information?.addressInformationToState !== "" && information?.addressInformationToState !== undefined) ||
    (information?.addressInformationToPostalCode !== null && information?.addressInformationToPostalCode !== "" && information?.addressInformationToPostalCode !== undefined) ||
    (information?.addressInformationToCountry !== null && information?.addressInformationToCountry !== "" && information?.addressInformationToCountry !== undefined);

export const isAnyAddressInformationNotEmpty = (information: IDocumentImportInformation): boolean =>
    isAddressInformationFromNotEmpty(information) || isAddressInformationToNotEmpty(information);

export const DeliveryAddressDetails = (props: DeliveryAddressDetailsProps) => {
    return (
        <>
            {/* Address From Section */}
            {isAddressInformationFromNotEmpty(props.information) && (
                <>
                    <Text variant={'bold-body'}>Ship from</Text>
                    <FixedGridLayout columns={5} >
                        <LockedField
                            fieldLabel={translate("#Core/AddressStreet")}
                            valueText={props.information?.addressInformationFromStreet || '-'}
                        />
                        <LockedField
                            fieldLabel={translate("#Core/AddressCity")}
                            valueText={props.information?.addressInformationFromCity || '-'}
                        />
                        <LockedField
                            fieldLabel={translate("#PurchaseToPay/state")}
                            valueText={props.information?.addressInformationFromState || '-'}
                        />
                        <LockedField
                            fieldLabel={translate("#PurchaseToPay/postalCode")}
                            valueText={props.information?.addressInformationFromPostalCode || '-'}
                        />
                        <LockedField
                            fieldLabel={translate("#Core/AddressCountry")}
                            valueText={props.information?.addressInformationFromCountry || '-'}
                        />
                    </FixedGridLayout>
                </>
            )}
            
            {/* Address To Section */}
            {isAddressInformationToNotEmpty(props.information) && (
                <>
                    <ContentDivider spacerMode='on' addBottomSpacer/>
                    <Text variant={'bold-body'}>Ship to</Text>
                    <FixedGridLayout columns={5}>
                        <LockedField
                            fieldLabel={translate("#Core/AddressStreet")}
                            valueText={props.information?.addressInformationToStreet || '-'}
                        />
                        <LockedField
                            fieldLabel={translate("#Core/AddressCity")}
                            valueText={props.information?.addressInformationToCity || '-'}
                        />
                        <LockedField
                            fieldLabel={translate("#PurchaseToPay/state")}
                            valueText={props.information?.addressInformationToState || '-'}
                        />
                        <LockedField
                             fieldLabel={translate("#PurchaseToPay/postalCode")}
                            valueText={props.information?.addressInformationToPostalCode || '-'}
                        />
                        <LockedField
                            fieldLabel={translate("#Core/AddressCountry")}
                            valueText={props.information?.addressInformationToCountry || '-'}
                        />
                    </FixedGridLayout>
                </>
            )}
        </>
    );
};